module.exports = __webpack_public_path__ + "static/media/error-dark.daf945b6.png";